import React from 'react';
import * as Autosuggest from "react-autosuggest";
import AutosuggestHighlightMatch from "autosuggest-highlight/match";
import AutosuggestHighlightParse from "autosuggest-highlight/parse";
import StrHelper from '../../util/str-helper';
import {isRomaji} from 'wanakana';
import $ from 'jquery'

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestions(datalist, value, searchName) {
  const trimmedValue = value.trim();

  if (trimmedValue === '') {
    return []
  }

  let result = []
  let regex = null

  if (StrHelper.isContainKanji(trimmedValue) || isRomaji(trimmedValue)) {
    regex = new RegExp(escapeRegexCharacters(trimmedValue), 'i');
    result = datalist.filter(item => regex.test(item[searchName]))
  } else {
    regex = new RegExp(escapeRegexCharacters(StrHelper.normalize(trimmedValue)), 'i')
    result = datalist.filter(item => regex.test(item.romaji))
  }

  return result
}

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);

    this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
    this.renderSuggestion = this.renderSuggestion.bind(this)
    this.getSuggestionValue = this.getSuggestionValue.bind(this)
    this.renderInputComponent = this.renderInputComponent.bind(this)
    this.clearSearch = this.clearSearch.bind(this)
    this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this)

    this.state = {
      value: '',
      suggestions: []
    };

    this.isFocused = props.isFocused
    this.isSelecting = false
    this.isListAllWhenTextEmpty = props.isListAllWhenTextEmpty
  }

  onChange = (event, { newValue, method }) => {
    let state = {value: newValue}
    if (newValue === "")
      this.callback(this.props.dataList)

    this.setState(state)
    this.props.onTextChange && this.props.onTextChange(newValue)
  };

  onKeyDown = (e) => {
    if (e.keyCode === 27 && this.state.value.trim() !== ''){
      this.clearSearch()
    } else if(e.keyCode === 13){
      if(this.isSelecting) {
        this.isSelecting = false
      } else {
        this.props.onPressEnter && this.props.onPressEnter()
      }
    }
  }

  onSuggestionsFetchRequested = ({ value }) => {
    let list = this.props.dataList
    if(value.trim() !== '') {
      list = getSuggestions(this.props.dataList || [], value, this.props.searchName || "name")
    }

    this.setState({
      suggestions: list
    })

    this.callback(list)
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  callback = (list) => {
    this.props.onChange && this.props.onChange(list)
  }

  onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    if (suggestion)
      this.callback([suggestion])

    this.props.selected && this.props.selected(suggestion)
    this.setState({ value: "" })

    if(method === "enter")
      this.isSelecting = true
  }

  renderSuggestion(suggestion, { query }) {
    const matches = AutosuggestHighlightMatch(suggestion[this.props.searchName], query);
    const parts = AutosuggestHighlightParse(suggestion[this.props.searchName], matches);

    return (
      <span>
        {parts.map((part, index) => {
          const className = part.highlight ? 'react-autosuggest__suggestion-match' : null;
          
          return (	
            <span className={className} key={index}>	
              {part.text}	
            </span>	
          );	
        })}
      </span>
    );
  }

  getSuggestionValue(suggestion) {
    return suggestion[this.props.searchName]
  }

  clearSearch() {
    this.setState({value: ''})
    this.props.onClear && this.props.onClear()
  }

  renderInputComponent(inputProps) {
    return (
      <div className={`input-group auto-complete-search ${this.props.isFocused && 'focus'} `}>
        <span className='icon-search'>
          <i className="fa fa-search" aria-hidden="true"></i>
        </span>
        <input {...inputProps} autoFocus={this.props.isFocused} />
        { this.state.value && <span className="icon-clear" onClick={this.clearSearch}>
          <i className="fa fa-times-circle" aria-hidden="true"></i>
        </span>}
      </div>
    )
  }

  shouldRenderSuggestions(value) {
    if(this.isListAllWhenTextEmpty)
      return true
    else if(value.trim() === '')
      return false

    return true
  }

  componentDidUpdate(){
    if(this.isFocused){
      $('.focus input.react-autosuggest__input').focus()
      this.isFocused = false
    }
  }

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: this.props.placeholder || 'Example: Type A',
      value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown
    };

    return (
      <Autosuggest
        suggestions={!this.props.notShowDropList ? suggestions : []}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        onSuggestionSelected={this.onSuggestionSelected}
        focusInputOnSuggestionClick={this.isListAllWhenTextEmpty}
        renderInputComponent={this.renderInputComponent}
        shouldRenderSuggestions={this.shouldRenderSuggestions}
      />
    );
  }
}

export default AutoComplete;
